// Bewaart het gekozen perspectief. localStorage, net als de tenantkeuze (zie
// selectedTenant.ts): de keuze geldt in elke tab en overleeft een herlaad.
// client.ts stuurt hem mee als x-perspective-id; de API controleert of de
// gebruiker het perspectief heeft en valt anders terug op het standaard-
// perspectief. Wordt gewist bij logout (zie authProvider).
const STORAGE_KEY = 'safezone.perspective';

export function getSelectedPerspective(): string | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw !== null && raw.trim() !== '' ? raw : null;
}

export function setSelectedPerspective(id: string): void {
  localStorage.setItem(STORAGE_KEY, id);
}

/**
 * Slaat het door /me bevestigde actieve perspectief op, maar alleen als de
 * keuze sinds het versturen van die /me niet veranderd is: een verlopen
 * antwoord mag een nieuwere keuze niet overschrijven. De opgeslagen keuze
 * wordt zo wel gecorrigeerd als de API op het standaardperspectief terugviel.
 */
export function adoptActivePerspective(requested: string | null, activeId: string): void {
  if (getSelectedPerspective() === requested) setSelectedPerspective(activeId);
}

export function clearSelectedPerspective(): void {
  localStorage.removeItem(STORAGE_KEY);
}

/**
 * Roept `onChanged` aan met het nieuwe perspectief-id wanneer een *ander*
 * tabblad van perspectief wisselt. Wissen telt niet: dat gebeurt bij
 * uitloggen en dat handelt onSelectedTenantCleared al af. Geeft een
 * opzegfunctie terug.
 */
export function onSelectedPerspectiveChanged(onChanged: (id: string) => void): () => void {
  const handler = (event: StorageEvent) => {
    if (event.storageArea !== localStorage) return;
    if (event.key !== STORAGE_KEY) return;
    const id = getSelectedPerspective();
    if (id !== null) onChanged(id);
  };
  window.addEventListener('storage', handler);
  return () => window.removeEventListener('storage', handler);
}
